// Spaltenanzahl der Grid-Ansicht (Library), als URL-Param `cols` persistiert —
// analog parse-view/parse-sort (Präsentations-State in der URL, nicht localStorage).
// Gilt nur auf großen Screens (lg+); Mobile/Tablet bleiben fix bei 2/3 Spalten.
export type GridCols = 3 | 4 | 5;

export const GRID_COLS_DEFAULT: GridCols = 5;

export function parseGridCols(value: string | null | undefined): GridCols {
  const n = Number(value);
  if (n === 3 || n === 4) return n;
  return GRID_COLS_DEFAULT; // 5 = Default; jeder ungültige/fehlende Wert fällt hierauf
}
